const { toast } = require("react-toastify")

export const getPropensityCategory = (score) => {
    if(score >=70 && score <= 100){
        return 'P1'
    } else if (score >=40 && score <= 69) {
        return 'P2'
    } else if (score <=39) {
        return 'P3'
    } else {
        return ''
    }
}

export const handleCall = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
};

export const handleMail = (email) => {
    if(email) toast.success(`Mail sent successfully to ${email}`)
    else toast.error(`Unable to mail at ${email}`)
};

export const sanitizeExtractionData = (data) => {
    // Implement any data sanitization logic if needed
    const result = {
      id: data._id || data.id || null,
      title: data.title || "Extraction 001",
      masterProject: data.project_details.master_project || "",
      project: data.project_details.project || "",
      addTemporaryValues: !!(data.project_details.temp_master_project_name || data.project_details.temp_project_name),
      tempMasterProject: data.project_details.temp_master_project_name || "",
      tempProject: data.project_details.temp_project_name || "",
      approxStartingPrice: data.project_details.approx_starting_price || "0",
      pincode: data.project_details.pincode || ""
    };
    if(data?.key) result.key = data.key;
    if(data?.workflow_step) result.workflow_step = data.workflow_step;
    if(data?.selected_version) result.selected_version = data.selected_version;
    if(data?.temp_selected_columns) result.temp_selected_columns = data.temp_selected_columns;
    if(data?.temp_custom_columns) result.temp_custom_columns = data.temp_custom_columns;
    // --- PATCH: Copy filePath, parquetPath, blobPath if present ---
    if(data?.filePath) result.filePath = data.filePath;
    if(data?.parquetPath) result.parquetPath = data.parquetPath;
    if(data?.blobPath) result.blobPath = data.blobPath;
    return result;
};

export const sanitizeId = (data) => {
    if(data._id){
        data = { ...data, id: data._id};
        delete data._id;
    }
    return data;
};


export const ensureItemsPresent = (fullArr, checkArr) => {
  const missingItems = checkArr.filter(item => !fullArr.includes(item));

  return {
    allPresent: missingItems.length === 0,
    updateStatus: missingItems.length > 0,
    updatedArray: missingItems.length > 0
      ? [...fullArr, ...missingItems]
      : fullArr
  };
}

export const convertStringDataToTableJson = (output) => {
  let parsedData = [];
  try {
    if (Array.isArray(output)) {
      // already array → maybe objects or json strings
      parsedData = output.map(o => (typeof o === 'string' ? JSON.parse(o) : o));
    } 
    else if (typeof output === "string") {
      const trimmed = output.trim();

      // Handles: ['{...}', '{...}']
      if (trimmed.startsWith("['") && trimmed.endsWith("']")) {
        const inner = trimmed.slice(2, -2);              // remove ['  and  ']
        parsedData = inner.split("', '").map(JSON.parse); // split and parse each
      } else {
        // fallback if backend ever sends real JSON
        parsedData = JSON.parse(output);
      }
    }
  } catch (err) {
    console.error("Failed to parse output", err);
    return { columns: [], rows: [] };
  }

  // --- corrected logic below ---

  const dataCategories = new Set();
  const dataGroups = new Set();
  
  parsedData.forEach(item => {
    const [dataGroup, dataCategory] = item.Key.split(','); // swapped correctly
    dataCategories.add(dataCategory);
    dataGroups.add(dataGroup);
  });

  const categories = Array.from(dataCategories).sort();
  const groups = Array.from(dataGroups).sort();

  const columns = ['Data Category', ...groups];

  const rows = categories.map((dataCategory, rowIndex) => {
    const row = {
      id: rowIndex.toString(),
      category: dataCategory
    };

    groups.forEach(dataGroup => {
      const matchingItem = parsedData.find(item =>
        item.Key === `${dataGroup},${dataCategory}` // swapped match
      );

      row[dataGroup] = {
        value: matchingItem ? matchingItem.Count : 0,
        dataGroup,
        dataCategory,
        meta: {
          dataGroup,
          dataCategory
        }
      };
    });

    return row;
  });

  return { columns, rows };
};
